import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  box: {
    display: 'grid',
    width: '100%',
    gap: 16,
  },
  filtersBox: {
    ...dFlex(),
    gap: 16,

    [theme.breakpoints.down(Breakpoint.Md)]: {
      display: 'grid',
      gridTemplateRows: 'auto',
      gridTemplateColumns: 'repeat(12, 1fr)',

      '& > :nth-of-type(1)': {
        gridColumn: 'span 12',
      },

      '& > :nth-of-type(2)': {
        gridColumn: 'span 5',
      },

      '& > :nth-of-type(3)': {
        gridColumn: 'span 4',
      },

      '& > :nth-of-type(4)': {
        gridColumn: 'span 3',
      },

      [theme.breakpoints.down(Breakpoint.Sm)]: {
        gap: 8,

        '& > :nth-of-type(1)': {
          gridColumn: 'span 12',
          order: 2,
        },

        '& > :nth-of-type(2)': {
          gridColumn: 'span 12',
          order: 1,
        },

        '& > :nth-of-type(3)': {
          gridColumn: 'span 12',
          order: 3,
        },

        '& > :nth-of-type(4)': {
          gridColumn: 'span 12',
          order: 4,
        },
      },
    },
  },
  input: {
    input: {
      '&.MuiOutlinedInput-input.MuiInputBase-inputSizeSmall': {
        height: '40px',
        minHeight: '40px',
      },
    },
  },
  selectBox: {
    ...dFlex(),
    width: '100%',

    '> div': {
      flex: 1,
    },

    '.MuiFormControl-root': {
      borderRadius: `${theme.borderRadius.md} 0 0 ${theme.borderRadius.md}`,
      '.MuiInputBase-root': {
        borderRadius: `${theme.borderRadius.md} 0 0 ${theme.borderRadius.md}`,
      },
    },
  },
  selectSortButton: {
    '&.MuiButtonBase-root.MuiButton-root': {
      border: 0,

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '96%',
        background: theme.secondary.s2,
        left: 0,
      },
    },
  },
  filterTabs: {
    width: '100%',

    '& .MuiButtonBase-root.MuiButton-root': {
      borderWidth: 0,
      flexGrow: 1,
    },
  },
  select: {
    '&.MuiInputBase-root': {
      height: 40,
    },
  },
  countFilter: {
    ...dFlex(),
    width: 20,
    height: 20,
    fontWeight: 600,
    marginLeft: 8,
    fontSize: '12px !important',
    backgroundColor: theme.accent.a6,
    borderRadius: theme.borderRadius.xxl,
  },
  clearBtn: {
    '&.MuiButtonBase-root.MuiButton-root': {
      minWidth: '115px !important',

      [theme.breakpoints.down(Breakpoint.Lg)]: {
        minWidth: 'initial !important',
      },
    },
  },
  children: {
    minWidth: 70,
  },
  closeIcon: {
    fontSize: 22,
    marginLeft: 8,
  },
}));

export default useStyles;
